const popFungi = [
  {
    id: 1,
    "description": "Hygrocybe Supernovus",
    "name": "#001 Vindicated Waxcap",
    "image": `/images/popfungi/1.png`,
    scene: 'store',
    hotspot: {
      top: '20%',
      left: '5%',
      width: '5%',
      height: '18%'
    },
    hidden: true,
    sold: true
  },
  {
    id: 2,
    "description": "Aspergillus Formidulosus",
    "name": "#002 Terry Berries",
    "image": `/images/popfungi/2.png`,
    scene: 'store',
    hotspot: {
      top: '25%',
      left: '21%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 3,
    "description": "Quadraperdon Quaeritus",
    "name": "#003 The Seeker",
    "image": `/images/popfungi/3.png`,
    scene: 'store',
    hotspot: {
      top: '40%',
      left: '15%',
      width: '5%',
      height: '18%'
    },
    hidden: true,
    sold: true
  },
  {
    id: 4,
    "description": "Coprinus Viburnum",
    "name": "#004 Shaggy Snowball",
    "image": `/images/popfungi/4.png`,
    scene: 'store',
    hotspot: {
      top: '65%',
      left: '15%',
      width: '5%',
      height: '18%'
    },
    hidden: true,
    sold: true
  },
  {
    id: 5,
    "description": "Coprinus Rickatus",
    "name": "#005 The Shaggy Sanchez",
    "image": `/images/popfungi/5.png`,
    scene: 'store',
    hotspot: {
      top: '60%',
      left: '25%',
      width: '5%',
      height: '18%'
    },
    hidden: true,
    sold: true
  },
  {
    id: 6,
    "description": "Hericium Felidraco",
    "name": "#006 Spikey Dragon Cap",
    "image": `/images/popfungi/6.png`,
    scene: 'store',
    hotspot: {
      top: '25%',
      left: '72%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 7,
    "description": "Hygrocybe Adumbratus",
    "name": "#007 Doodle Waxcap",
    "image": `/images/popfungi/7.png`,
    scene: 'store',
    hotspot: {
      top: '79%',
      left: '63%',
      width: '8%',
      height: '20%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 8,
    "description": "Hericium Otiosos",
    "name": "#008 Lazy Lions Mane",
    "image": `/images/popfungi/8.png`,
    scene: 'store',
    hotspot: {
      top: '41%',
      left: '78%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 9,
    "description": "Tylopilus Samuraeus",
    "name": "#009 Shogun Bolete",
    "image": `/images/popfungi/9.png`,
    scene: 'store',
    hotspot: {
      top: '61%',
      left: '74%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 10,
    "description": "Amanita Simiae",
    "name": "#010 Bored Agaric",
    "image": `/images/popfungi/10.png`,
    scene: 'store',
    hotspot: {
      top: '60%',
      left: '80%',
      width: '5%',
      height: '18%'
    },
    hidden: true,
    sold: true
  },
  {
    id: 11,
    name: `PopFungi #011`,
    description: `Trick or Treat?`,
    image: `/images/popfungi/halloween.png`,
    scene: 'halloween',
    hotspot: {
      top: '65%',
      left: '5%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: true
  },
  {
    id: 12,
    name: `PopFungi #012`,
    description: `Trick or Treat?`,
    image: `/images/popfungi/halloween.png`,
    scene: 'halloween',
    hotspot: {
      top: '15%',
      left: '20%',
      width: '8%',
      height: '50%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 13,
    name: `PopFungi #013`,
    description: `Trick or Treat?`,
    image: `/images/popfungi/halloween.png`,
    scene: 'halloween',
    hotspot: {
      top: '5%',
      left: '35%',
      width: '12%',
      height: '30%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 14,
    name: `PopFungi #014`,
    description: `Trick or Treat?`,
    image: `/images/popfungi/halloween.png`,
    scene: 'halloween',
    hotspot: {
      top: '35%',
      left: '75%',
      width: '5%',
      height: '30%'
    },
    hidden: false,
    sold: true
  },
  {
    id: 15,
    name: `PopFungi #015`,
    description: `Trick or Treat?`,
    image: `/images/popfungi/halloween.png`,
    scene: 'halloween',
    hotspot: {
      top: '60%',
      left: '85%',
      width: '15%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 16,
    "description": "Cortinareus Araneas",
    "name": "#016 Spider's Webcap",
    "image": `/images/popfungi/16.png`,
    scene: 'store',
    hotspot: {
      top: '20%',
      left: '12%',
      width: '5%',
      height: '18%'
    },
    hidden: true,
    sold: true
  },
  {
    id: 17,
    "description": "Rubroboletus Nebulae",
    "name": "#017 The Bitter Sister",
    "image": `/images/popfungi/17.png`,
    scene: 'store',
    hotspot: {
      top: '45%',
      left: '18%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 18,
    "description": "Morchella Athanasios",
    "name": "#018 Immorel Immortal",
    "image": `/images/popfungi/18.png`,
    scene: 'store',
    hotspot: {
      top: '65%',
      left: '80%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 19,
    "description": "Xerocomellus Colossi",
    "name": "#019 Cracking Root",
    "image": `/images/popfungi/19.png`,
    scene: 'store',
    hotspot: {
      top: '65%',
      left: '80%',
      width: '5%',
      height: '18%'
    },
    hidden: true,
    sold: true
  },
  {
    id: 20,
    "description": "Chroogomphus Ferrous",
    "name": "#020 Iron Slimecap",
    "image": `/images/popfungi/20.png`,
    scene: 'store',
    hotspot: {
      top: '79%',
      left: '63%',
      width: '8%',
      height: '30%'
    },
    hidden: true,
    sold: true
  },
  {
    id: 21,
    "description": "Hygrocybe Glebis",
    "name": "#021 Oh My Globshroom",
    "image": `/images/popfungi/21.png`,
    scene: 'store',
    hotspot: {
      top: '20%',
      left: '12%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 22,
    "description": "Quadraperdon Mo",
    "name": "#022 M'lady",
    "image": `/images/popfungi/22.png`,
    scene: 'store',
    hotspot: {
      top: '54%',
      left: '38%',
      width: '3%',
      height: '10%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 23,
    "description": "Lactarius Bullagumi",
    "name": "#023 Bubblegum Candycap",
    "image": `/images/popfungi/23.png`,
    scene: 'store',
    hotspot: {
      top: '20%',
      left: '80%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 24,
    "description": "Hygrocybe Canis",
    "name": "#024 Woofcap",
    "image": `/images/popfungi/24.png`,
    scene: 'store',
    hotspot: {
      top: '65%',
      left: '15%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 25,
    "description": "Agaricus Anthropus",
    "name": "#025 Finn the Mushroom",
    "image": `/images/popfungi/25.png`,
    scene: 'store',
    hotspot: {
      top: '60%',
      left: '24%',
      width: '5%',
      height: '18%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 26,
    "description": "Omphalatus Fulgur",
    "name": "#026 Pikashroom",
    "image": `/images/popfungi/26.png`,
    scene: 'forestDay',
    hotspot: {
      top: '28%',
      left: '55%',
      width: '8%',
      height: '25%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 27,
    "description": "A wild Pokeshroom appeared.",
    "name": "#027 Who's that Pokeshroom?!",
    "image": `/images/popfungi/pokeshroom2.png`,
    scene: 'plainsDay',
    hotspot: {
      top: '70%',
      left: '52%',
      width: '8%',
      height: '25%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 28,
    "description": "A wild Pokeshroom appeared.",
    "name": "#028 Who's that Pokeshroom?!",
    "image": `/images/popfungi/pokeshroom3.png`,
    scene: 'pool',
    hotspot: {
      top: '15%',
      left: '40%',
      width: '8%',
      height: '25%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 29,
    "description": "A wild Pokeshroom appeared.",
    "name": "#029 Who's that Pokeshroom?!",
    "image": `/images/popfungi/pokeshroom4.png`,
    scene: 'launchpadDay',
    hotspot: {
      top: '50%',
      left: '59%',
      width: '8%',
      height: '25%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 30,
    "description": "A wild Pokeshroom appeared.",
    "name": "#030 Who's that Pokeshroom?!",
    "image": `/images/popfungi/pokeshroom5.png`,
    scene: 'pyramidsDay',
    hotspot: {
      top: '21%',
      left: '87%',
      width: '10%',
      height: '30%'
    },
    hidden: false,
    sold: false
  },
  {
    id: 31,
    "description": "Chroogomphus Machanim",
    "name": "#031 Golden Bolt Head",
    "image": `/images/popfungi/31.png`,
    scene: '',
    hotspot: {
      top: '21%',
      left: '87%',
      width: '10%',
      height: '30%'
    },
    hidden: true,
    sold: false
  },
  {
    id: 32,
    "description": "Chroogomphus Rootdoot",
    "name": "#032 Beep Booper",
    "image": `/images/popfungi/32.png`,
    scene: '',
    hotspot: {
      top: '0%',
      left: '0%',
      width: '0%',
      height: '0%'
    },
    hidden: true,
    sold: false
  },
  {
    id: 33,
    "description": "Hygrocybe Paterna",
    "name": "#033 Dark Father",
    "image": `/images/popfungi/33.png`,
    scene: '',
    hotspot: {
      top: '0%',
      left: '0%',
      width: '0%',
      height: '0%'
    },
    hidden: true,
    sold: false
  },
  {
    id: 34,
    "description": "Chroogomphus Mortem",
    "name": "#034 Shiny Death Cap",
    "image": `/images/popfungi/34.png`,
    scene: '',
    hotspot: {
      top: '0%',
      left: '0%',
      width: '0%',
      height: '0%'
    },
    hidden: true,
    sold: false
  }
]

export default popFungi
